import axios from "axios";

const TOKEN_KEY = "ahh_access_token";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Attach the Bearer token so saves still work when the browser blocks
// session cookies (e.g. the preview running inside an embedded frame).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => {
    if (res.data && res.data.access_token) {
      localStorage.setItem(TOKEN_KEY, res.data.access_token);
    }
    return res;
  },
  async (err) => {
    const original = err.config;
    const url = original?.url || "";
    if (err.response?.status === 401 && !original?._retry && !url.includes("/auth/")) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
        }
        const { data } = await refreshing;
        if (data?.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
        return api(original);
      } catch {
        localStorage.removeItem(TOKEN_KEY);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
